import TimeOffHeatmapPage from '@/components/pages/calendar/time-off-heatmap/time-off-heatmap-page';

function TimeOffPage() {
  return (
    <div className="h-full w-full">
      <TimeOffHeatmapPage />
    </div>
  );
}

export default TimeOffPage;
